module.exports = __webpack_public_path__ + "img/customer-service.548522a4.png";